import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc-app/design-system';
import { FormInput } from '@occc-app/Offer/components/FormInput';

import {
  greaterThanZeroValidation,
  numberValidation,
  requiredValidation,
  withFormEventValidation,
} from '../../validatableComponent';
import { ButtonGroup } from '../../ButtonGroup';
import { State } from '../redux';

const CountThresholdFormInput = withFormEventValidation(
  FormInput,
  requiredValidation,
  numberValidation,
  greaterThanZeroValidation,
);

const ValuesFormInput = withFormEventValidation(FormInput, requiredValidation);

type ComponentState = State['emConfiguration']['perItemsAccumulated'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  fieldDisabled: (field: Fields) => boolean;
};

const PerItemsAccumulatedConfiguration: React.FC<Props> = (props) => {
  const { countPer, countThreshold, fieldDisabled, itemKey, summationMode, values } = props;

  return (
    <Box>
      <Box my={4}>
        <ButtonGroup
          label='Summation Mode'
          name='summationMode'
          readonly={fieldDisabled('summationMode')}
          selectedValue={summationMode}
        >
          <ButtonGroup.Option value='include'>Include</ButtonGroup.Option>
          <ButtonGroup.Option value='exclude'>Exclude</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <ButtonGroup
          label='Count Per'
          name='countPer'
          readonly={fieldDisabled('countPer')}
          selectedValue={countPer}
        >
          <ButtonGroup.Option value='quantity'>Quantity</ButtonGroup.Option>
          <ButtonGroup.Option value='money_amount'>Money Amount</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <CountThresholdFormInput
          id='countThreshold'
          label='Count Threshold'
          readonly={fieldDisabled('countThreshold')}
          type='text'
          value={countThreshold}
          required={true}
        />
      </Box>

      <Box mb={4}>
        <ButtonGroup
          label='Line item key'
          name='itemKey'
          readonly={fieldDisabled('itemKey')}
          selectedValue={itemKey}
        >
          <ButtonGroup.Option value='group'>Group</ButtonGroup.Option>
          <ButtonGroup.Option value='upc'>UPC</ButtonGroup.Option>
          <ButtonGroup.Option value='sku'>SKU</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <ValuesFormInput
          id='values'
          label='Values'
          readonly={fieldDisabled('values')}
          type='text'
          value={values.join(', ')}
          required={true}
        />
        <Typography variant='body2'>Enter a comma seperated list of values</Typography>
      </Box>
    </Box>
  );
};

export { PerItemsAccumulatedConfiguration };
